module.exports = __webpack_public_path__ + "assets/6eac18fa40f218c9a35f9e47cda3d36f.svg";